export {
  OnboardingQuestionSlider,
  OnboardingQuestionSliderProps,
} from './OnboardingQuestionSlider';
